import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Messages } from './Messages';

export const MessagesContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<Messages />} />
      <Route path=":id" element={<Messages />} />
    </Routes>
  );
}; 